import React, { useEffect, useState, useCallback } from 'react';
import { Input } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const FastInput = React.memo(
  ({ name, type, value, onChange, disabled, className, numericOnly, ...props }) => {
    const [customValue, setCustomValue] = useState(value);

    const handleChange = useCallback(
      e => setCustomValue(numericOnly ? e.target.value.replace(/\D/g, '') : e.target.value),
      [numericOnly]
    );

    useEffect(() => {
      if (customValue !== value) {
        setCustomValue(value);
      }
    }, [value]);

    useEffect(() => {
      const timeout = setTimeout(() => {
        if (onChange) {
          onChange(customValue);
        }
      }, 300);
      return () => clearTimeout(timeout);
    }, [customValue]);

    return (
      <Input
        type={type || 'text'}
        value={customValue ?? ''}
        disabled={disabled}
        onChange={handleChange}
        autoComplete="off"
        {...(className ? { className } : {})}
        {...(name ? { name } : {})}
        {...props}
      />
    );
  },
  (prev, next) => prev.value === next.value && prev.disabled === next.disabled && prev.className === next.className
);

export default FastInput;

FastInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
  numericOnly: PropTypes.bool,
};
